/* ============================================================
   MÉTODO CLARIDAD — UI base
   Scroll suave a la oferta · sticky CTA · acordeón · reveals · contadores
   Vanilla, sin dependencias.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1. Scroll suave — TODOS los CTA van a #oferta
     --------------------------------------------------------- */
  function initScrollCtas() {
    document.addEventListener('click', function (ev) {
      var link = ev.target.closest('[data-cl-scroll]');
      if (!link) return;

      var target = document.querySelector('#oferta');
      if (!target) return;

      ev.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      // Aviso de desarrollo: el producto de Shopify todavía no está creado.
      if (link.hasAttribute('data-cl-cart-pending')) {
        console.warn(
          '[CLARIDAD] Falta el ID de variante del producto. ' +
          'Cargalo en Personalizar tema → Configuración → "Metodo CLARIDAD (infoproducto)". ' +
          'Mientras tanto, el botón de compra hace scroll a la oferta.'
        );
      }
    });
  }

  /* ---------------------------------------------------------
     2. Sticky CTA — aparece pasado el 30% de scroll,
        se esconde cuando #oferta está visible (no compite con el botón real)
     --------------------------------------------------------- */
  function initSticky() {
    var sticky = document.querySelector('[data-cl-sticky]');
    if (!sticky) return;

    var oferta = document.querySelector('#oferta');
    var footer = document.querySelector('.cl-footer');

    // Se cachea el alto scrolleable para no leer scrollHeight en cada scroll.
    var scrollable = 0;
    function measure() {
      scrollable = document.documentElement.scrollHeight - window.innerHeight;
    }

    // Visibilidad por getBoundingClientRect en vez de IntersectionObserver:
    // una lectura por scroll ya throttleado es barata, y evita depender de
    // callbacks que no se entregan con la pestaña en segundo plano.
    function onScreen(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    function update() {
      var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      // Se esconde sobre la oferta y sobre el footer para no competir
      // con el botón real de compra.
      var show = progress > 0.3 && !onScreen(oferta) && !onScreen(footer);
      sticky.classList.toggle('is-visible', show);
    }

    // Throttle por tiempo, NO por requestAnimationFrame: en una pestaña en
    // segundo plano rAF no corre, y con un flag "ticking" el sticky quedaba
    // trabado para siempre al volver. update() es barato (lecturas cacheadas).
    var last = 0;
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last < 60) return;
      last = now;
      update();
    }, { passive: true });

    window.addEventListener('resize', function () { measure(); update(); }, { passive: true });

    measure();
    update();
  }

  /* ---------------------------------------------------------
     3. Acordeón (FAQ) — altura animada, accesible
     --------------------------------------------------------- */
  function initAccordion() {
    var items = document.querySelectorAll('.cl-acc__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.cl-acc__btn');
      var panel = item.querySelector('.cl-acc__panel');
      if (!btn || !panel) return;

      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Acordeón exclusivo: cerrar los demás
        items.forEach(function (other) {
          if (other === item) return;
          var otherPanel = other.querySelector('.cl-acc__panel');
          var otherBtn = other.querySelector('.cl-acc__btn');
          other.classList.remove('is-open');
          if (otherPanel) otherPanel.style.height = '0px';
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (isOpen) {
          item.classList.remove('is-open');
          panel.style.height = '0px';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          panel.style.height = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Recalcular la altura del panel abierto si cambia el ancho
    window.addEventListener('resize', function () {
      var open = document.querySelector('.cl-acc__item.is-open .cl-acc__panel');
      if (open) open.style.height = open.scrollHeight + 'px';
    });
  }

  /* ---------------------------------------------------------
     4. Reveals al hacer scroll
     --------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.cl-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     5. Contadores animados — <span data-cl-count="95">
     --------------------------------------------------------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-cl-count]');
    if (!els.length) return;

    function run(el) {
      var end = parseFloat(el.getAttribute('data-cl-count'));
      if (isNaN(end)) return;
      var prefix = el.getAttribute('data-cl-prefix') || '';
      var suffix = el.getAttribute('data-cl-suffix') || '';
      var finalText = prefix + Math.round(end).toLocaleString('en-US') + suffix;

      // Si no hay animación posible, se escribe el número y listo.
      if (reduceMotion || document.visibilityState !== 'visible') {
        el.textContent = finalText;
        return;
      }

      var duration = 1100;
      var start = null;
      var done = false;

      // Red de seguridad: si la pestaña se va a segundo plano, rAF deja de
      // correr y el contador quedaría clavado en 0. Este timeout garantiza
      // que siempre termine mostrando la cifra correcta.
      var safety = window.setTimeout(function () {
        if (!done) { done = true; el.textContent = finalText; }
      }, duration + 400);

      function step(ts) {
        if (done) return;
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = prefix + Math.round(end * eased).toLocaleString('en-US') + suffix;
        if (p < 1) {
          window.requestAnimationFrame(step);
        } else {
          done = true;
          window.clearTimeout(safety);
        }
      }
      window.requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------- */
  function init() {
    initScrollCtas();
    initSticky();
    initAccordion();
    initReveals();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
